import { useEffect } from "react";
import { NumericFormat } from "react-number-format";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hook";
import { formatAmount } from "../../lib/utilis";
import { colors } from "../../ui/colors";
import { CurrencyEuroIcon } from "../../ui/icons/currencyEuroIcon";
import { InvoiceIcon } from "../../ui/icons/invoiceIcon";
import { LayoutComponent } from "../../ui/layout";
import { BillowButton } from "../../ui/molecules/billowButton";
import { InputComponent } from "../../ui/molecules/input";
import { SpinnerComponent } from "../../ui/molecules/spinner";
import { ErrorPopup } from "../../ui/organisms/errorPopup";
import { FormRow } from "../../ui/organisms/formRow/formRow";
import { Pagination } from "../../ui/organisms/pagination";
import { MenuItems } from "../../ui/organisms/sidebar/dto";
import { SuccessPopup } from "../../ui/organisms/successPopup";
import {
    findCustomerByIds,
    setFindCustomerByIdsStatus,
} from "../customer/slice";
import {
    editInvoiceAmount,
    findAllPartition,
    findByIdInvoiceAmount,
    partitionPartitionMetrics,
    recoverPartitionMetrics,
    setEditInvoiceAmountStatus,
    setPartitionFilterPage,
    setPartitionPartitionMetricsStatus,
    setRecoverPartitionMetricsStatus,
    setUpsertInvoiceAmountCerts,
} from "./slice";

export function Partition() {
  const dispatch = useAppDispatch();
  const invoiceAmountState = useAppSelector((state) => state.invoiceAmount);
  const customerState = useAppSelector((state) => state.customer);

  useEffect(() => {
    const path = window.location.pathname;
    dispatch(findByIdInvoiceAmount(path.split("/")[2]));
  }, []);

  useEffect(() => {
    if (invoiceAmountState.findByIdInvoiceAmountStatus === "successfully") {
      dispatch(
        findAllPartition({
          pageSize: 0,
          sortBy: "",
          page: 0,
          sort: 0,
          month: invoiceAmountState.findByIdInvoiceAmountResponse?.month || 0,
          year: invoiceAmountState.findByIdInvoiceAmountResponse?.year || 0,
        }),
      );
      dispatch(
        setUpsertInvoiceAmountCerts(
          invoiceAmountState.findByIdInvoiceAmountResponse?.amount_cents || 0,
        ),
      );
    }
  }, [invoiceAmountState.findByIdInvoiceAmountStatus]);

  useEffect(() => {
    if (invoiceAmountState.findAllPartitionStatus === "successfully") {
      dispatch(
        findCustomerByIds(
          invoiceAmountState.findAllPartitionResponse?.partitions.map(
            (partition) => partition.customer_id,
          ) || [],
        ),
      );
    }
  }, [invoiceAmountState.findAllPartitionStatus]);

  useEffect(() => {
    if (customerState.findCustomerByIdsStatus === "successfully") {
      dispatch(setFindCustomerByIdsStatus("idle"));
    }
  }, [customerState.findCustomerByIdsStatus]);

  useEffect(() => {
    if (invoiceAmountState.editInvoiceAmountStatus === "successfully") {
      dispatch(
        findByIdInvoiceAmount(
          invoiceAmountState.findByIdInvoiceAmountResponse!.id.toString(),
        ),
      );
    }
  }, [invoiceAmountState.editInvoiceAmountStatus]);

  useEffect(() => {
    if (
      invoiceAmountState.recoverPartitionMetricsStatus === "successfully" &&
      invoiceAmountState.findByIdInvoiceAmountResponse?.id
    ) {
      dispatch(
        findAllPartition({
          pageSize: 0,
          sortBy: "",
          page: 0,
          sort: 0,
          month: invoiceAmountState.findByIdInvoiceAmountResponse?.month || 0,
          year: invoiceAmountState.findByIdInvoiceAmountResponse?.year || 0,
        }),
      );
      dispatch(setRecoverPartitionMetricsStatus("idle"));
    }
  }, [
    invoiceAmountState.recoverPartitionMetricsStatus,
    invoiceAmountState.findByIdInvoiceAmountResponse?.id,
  ]);

  useEffect(() => {
    if (invoiceAmountState.partitionPartitionMetricsStatus === "successfully") {
      dispatch(
        findByIdInvoiceAmount(
          invoiceAmountState.findByIdInvoiceAmountResponse!.id.toString(),
        ),
      );
    }
    dispatch(setPartitionPartitionMetricsStatus("idle"));
  }, [invoiceAmountState.partitionPartitionMetricsStatus]);

  const formatMonthName = (month: number) => {
    const monthNames = [
      "Gennaio",
      "Febbraio",
      "Marzo",
      "Aprile",
      "Maggio",
      "Giugno",
      "Luglio",
      "Agosto",
      "Settembre",
      "Ottobre",
      "Novembre",
      "Dicembre",
    ];
    return monthNames[month - 1];
  };

  const nameToShow = invoiceAmountState.findByIdInvoiceAmountResponse
    ? `${formatMonthName(invoiceAmountState.findByIdInvoiceAmountResponse.month)} ${invoiceAmountState.findByIdInvoiceAmountResponse.year}`
    : "";

  return (
    <LayoutComponent
      menuItem={MenuItems.INVOICEAMOUNT}
      headingLabel={nameToShow}
      headingButtons={[
        <>
          {!invoiceAmountState.findByIdInvoiceAmountResponse?.partitioned && (
            <BillowButton
              onClick={() => {
                dispatch(
                  editInvoiceAmount({
                    id: invoiceAmountState.findByIdInvoiceAmountResponse!.id.toString(),
                    body: {
                      amount_cents:
                        invoiceAmountState.editInvoiceAmountRequest
                          .amount_cents,
                      month: 0,
                      year: 0,
                    },
                  }),
                );
              }}
              label="Modifica costo mensile Cloud"
              iconPosition={"left"}
              variant={"solid"}
              disabled={
                invoiceAmountState.editInvoiceAmountStatus === "loading" ||
                invoiceAmountState.recoverPartitionMetricsStatus ===
                  "loading" ||
                invoiceAmountState.partitionPartitionMetricsStatus === "loading"
              }
            />
          )}
          {invoiceAmountState.findAllPartitionResponse?.partitions.length ===
            0 && (
            <BillowButton
              onClick={() => {
                dispatch(recoverPartitionMetrics());
              }}
              label="Recupera metriche"
              iconPosition={"left"}
              variant={"solid"}
              disabled={
                invoiceAmountState.recoverPartitionMetricsStatus ===
                  "loading" ||
                invoiceAmountState.editInvoiceAmountStatus === "loading"
              }
            />
          )}
          {invoiceAmountState.findAllPartitionResponse?.partitions.length !==
            0 &&
            !invoiceAmountState.findByIdInvoiceAmountResponse?.partitioned && (
              <BillowButton
                onClick={() => {
                  dispatch(partitionPartitionMetrics());
                }}
                label="Partiziona metriche"
                iconPosition={"left"}
                variant={"solid"}
                disabled={
                  invoiceAmountState.partitionPartitionMetricsStatus ===
                    "loading" ||
                  invoiceAmountState.editInvoiceAmountStatus === "loading"
                }
              />
            )}
        </>,
      ]}
      breadcrumbItems={["Gestione costi Cloud / " + nameToShow]}
      breadcrumbIcon={<InvoiceIcon size={"20"} color={"#6237fb"} />}
    >
      <div className="flex flex-col gap-5 flex-1">
        <SuccessPopup
          message="Importo fattura modificato con successo!"
          active={invoiceAmountState.editInvoiceAmountStatus === "successfully"}
          close={() => dispatch(setEditInvoiceAmountStatus("idle"))}
        />
        <ErrorPopup
          message="La modifica dell'importo fattura non è andata a buon fine."
          active={invoiceAmountState.editInvoiceAmountStatus === "failed"}
          close={() => {
            dispatch(setUpsertInvoiceAmountCerts(0));
            dispatch(setEditInvoiceAmountStatus("idle"));
          }}
        />
        {invoiceAmountState.findByIdInvoiceAmountStatus === "loading" ||
        invoiceAmountState.editInvoiceAmountStatus === "loading" ||
        invoiceAmountState.findAllPartitionStatus === "loading" ||
        invoiceAmountState.recoverPartitionMetricsStatus === "loading" ||
        invoiceAmountState.partitionPartitionMetricsStatus === "loading" ||
        customerState.findCustomerByIdsStatus === "loading" ? (
          <div className="flex justify-center items-center w-full flex-1">
            <SpinnerComponent />
          </div>
        ) : (
          <>
            <FormRow
              label="Mese e Anno"
              children={[
                <>
                  <InputComponent
                    key={"edit-invoice-month-name"}
                    type={"text"}
                    placeholder="Mese"
                    value={formatMonthName(
                      invoiceAmountState.findByIdInvoiceAmountResponse?.month ||
                        0,
                    )}
                    disabled
                  />
                  <InputComponent
                    key={"edit-invoice-year"}
                    type={"text"}
                    placeholder="Anno"
                    value={
                      invoiceAmountState.findByIdInvoiceAmountResponse?.year ||
                      0
                    }
                    disabled
                  />
                </>,
              ]}
            />
            <FormRow
              label="Costo mensile Cloud"
              children={[
                <NumericFormat
                  key={"edit-customer-amount"}
                  customInput={InputComponent}
                  placeholder="Costo mensile Cloud"
                  value={
                    (invoiceAmountState.editInvoiceAmountRequest.amount_cents ||
                      0) / 100
                  }
                  onValueChange={(values) => {
                    const amount = values.floatValue || 0;
                    dispatch(
                      setUpsertInvoiceAmountCerts(Math.round(amount * 100)),
                    );
                  }}
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  fixedDecimalScale={true}
                  allowNegative={false}
                  disabled={
                    invoiceAmountState.findByIdInvoiceAmountResponse
                      ?.partitioned
                  }
                  startIcon={
                    <CurrencyEuroIcon size={"20"} color={colors.neutral[400]} />
                  }
                />,
              ]}
            />
            <div className="w-full flex flex-col gap-4 bg-neutral-100 rounded-tr-xl rounded-tl-xl overflow-auto">
              <div>
                <table className="w-full">
                  <thead className="h-[56px] font-semibold text-neutral-500 text-text-xs">
                    <tr>
                      <th className="text-left">
                        <div className="flex py-4 px-4 gap-1">MESE</div>
                      </th>
                      {invoiceAmountState.findAllPartitionResponse?.partitions
                        .length !== 0 && (
                        <>
                          <th className="text-left">ANNO</th>
                          <th className="text-left">NAMESPACE</th>
                          <th className="text-left">CLIENTE</th>
                          <th className="text-left">QUOTA REALE</th>
                        </>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {invoiceAmountState.findAllPartitionResponse?.partitions
                      .length === 0 ? (
                      <tr className="bg-white h-[56px] border-b-[1px] border-b-neutral-100 w-full">
                        <td className="py-4 px-4 text-text-sm font-medium text-neutral-500">
                          Nessuna partizione
                        </td>
                      </tr>
                    ) : (
                      invoiceAmountState.findAllPartitionResponse?.partitions.map(
                        (item) => (
                          <tr
                            className="bg-white h-[56px] border-b-[1px] border-b-neutral-100"
                            key={item.id}
                          >
                            <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600 hover:text-neutral-500 cursor-pointer">
                              {formatMonthName(item.month)}
                            </td>
                            <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                              {item.year}
                            </td>
                            <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                              {item.namespace}
                            </td>
                            <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                              {
                                customerState.findCustomerByIdsResponse?.find(
                                  (id) =>
                                    item.customer_id.toString() ===
                                    id.id.toString(),
                                )?.business_name
                              }
                            </td>
                            <td className="py-4 px-2 text-text-sm font-semibold text-neutral-600">
                              {formatAmount(item.amount_partition_cents) + " €"}
                            </td>
                          </tr>
                        ),
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {invoiceAmountState.findAllPartitionResponse !== undefined &&
              invoiceAmountState.findAllPartitionResponse.partitions.length >
                0 && (
                <div className="flex bg-white drop-shadow-sm items-center justify-center p-2">
                  <Pagination
                    pages={
                      invoiceAmountState.findAllPartitionResponse.totalPage || 1
                    }
                    currentPage={
                      invoiceAmountState.findAllPartitionResponse.page
                    }
                    setPage={(page) => dispatch(setPartitionFilterPage(page))}
                  />
                </div>
              )}
          </>
        )}
      </div>
    </LayoutComponent>
  );
}
